module.exports = __webpack_public_path__ + "static/img/nodata.a08b7a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/image/nodata.png
// module id = 8cp5
// module chunks = 1